// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__StjpV","title":"FrontImage_title__1URnv"};